import useSWR, { SWRConfiguration } from "swr";
import { IEirSalesNle } from "../interfaces/models/IEirSalesNLE";
import { getNLE } from "../apis/nle";

export const useNLE = (prequalId: string, options: SWRConfiguration = {}) =>
    useSWR<IEirSalesNle>(["useNLE", prequalId], { ...options, fetcher: () => getNLE(prequalId) });
